import { isArrayEquals } from '../../../../actions/utilAction';

// validations for the authorization Procedures ...

const validate = (values) => {
  const error = {};

  if (!values.patientInsuranceId || !Number.isInteger(values.patientInsuranceId)) {
    error.patientInsuranceId = 'Please select Insurance Company';
  }
  if (!values.authorizationTitle) {
    error.authorizationTitle = 'Please enter authorization title';
  }
  if (!values.authorizationNumber) {
    error.authorizationNumber = 'Please enter authorization number';
  }
  if (!values.startDate) {
    error.startDate = 'Please select start date';
  }
  if (!values.endDate) {
    error.endDate = 'Please select end date';
  } 
  // else if (values.endDate <= values.startDate) {
  //   error.endDate = 'Invalid end date';
  // }

  if (!values.Procedure || !values.Procedure.length) {
    error.Procedure = { _error: 'At least one procedure code must be selected' };
  } else {
    const ProcedureArrayErrors = [];
    const allProceduresArray = values.Procedure || [];
    values.Procedure.forEach((procedure, index) => {
      const restProceduresArray = allProceduresArray.filter((obj, cptIndex) => cptIndex !== index);
      const ProcedureErrors = {};
      if (!procedure.cptid || !procedure.cptid.length) {
        ProcedureErrors.cptid = 'Please select procedure code';
      } else if (procedure.cptid.length) {
        let isGroupExist = (restProceduresArray || []).find((procObj) => isArrayEquals(procObj.cptid, procedure.cptid) && isArrayEquals(procObj.modifiers || [], procedure.modifiers || []));
        // console.log(restProceduresArray, isGroupExist)
        if (isGroupExist) {
          ProcedureErrors.cptid = 'Please select another procedure and modifier group';
        }
      }
      if (!procedure || !procedure.unit) {
        ProcedureErrors.unit = 'Please enter units';
      }
      if (!procedure || !Number.isInteger(procedure.typeid)) {
        ProcedureErrors.typeid = 'Please select type';
      }
      ProcedureArrayErrors[index] = ProcedureErrors;
      return ProcedureErrors;
    });
    if (ProcedureArrayErrors.length) {
      error.Procedure = ProcedureArrayErrors;
    }
  }
  return error;
};

export default validate;



// WEBPACK FOOTER //
// ./src/modules/patients/components/authorization/validate.js